import { imageBaseUrl } from '../config/http';

export const resolveItemImageUrl = (item) => {
  if (!item) return '';
  let gData = item.gambar1 || item.gambar || item.foto;
  if (typeof gData === 'string' && (gData.startsWith('[') || gData.startsWith('{'))) {
    try {
      gData = JSON.parse(gData);
    } catch (e) {}
  }
  if (Array.isArray(gData) && gData.length > 0) {
    const path =
      gData[0]?.asli ||
      gData[0]?.thumbnail ||
      (typeof gData[0] === 'string' ? gData[0] : '');
    return path ? (path.startsWith('http') ? path : `${imageBaseUrl}${path}`) : '';
  }
  if (typeof gData === 'string' && gData.length > 0) {
    return gData.startsWith('http') ? gData : `${imageBaseUrl}${gData}`;
  }
  return '';
};
